import {
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

/**
 * Rol bo'yicha filtr — tanlansa o'sha roldagi BARCHA xodimlarga oid natijalar chiqadi.
 */
const RoleFilter = ({ query = 'role', label, size = undefined, className }) => {
  const { t } = useTranslation();
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);
  const [selected, setSelected] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();

  const { data, isLoading, isFetching } = useQuery({
    queryKey: 'roleFilterSelect',
    queryFn: async function () {
      const response = await axiosPrivate.get('/dictionary/roles');
      return response.data.data;
    },
    enabled: !hasError,
    onError: () => {
      setHasError(true);
    },
    retry: false,
  });

  useEffect(() => {
    if (searchParams.get(query)) setSelected(searchParams.get(query));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams.get(query)]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    searchParams.set(query, value);
    let localSearchParams = Object.fromEntries([...searchParams]);
    if (!isNaN(localSearchParams.page)) {
      searchParams.set('page', 1);
    }
    setSearchParams(searchParams);
    setSelected(value);
  };

  const handleClearSelectBox = () => {
    searchParams.delete(query);
    setSelected('');
    setSearchParams(searchParams);
  };

  return (
    <FormControl className={className} fullWidth color='formColor'>
      <InputLabel id='role-filter-label'>
        {t(label || 'common.filter.role')}
      </InputLabel>
      <Select
        labelId='role-filter-label'
        id='role-filter-chip'
        label={t(label || 'common.filter.role')}
        value={selected}
        onChange={handleChange}
        color='formColor'
        variant='outlined'
        className={className}
        size={size}
        MenuProps={{
          id: 'role-filter-select-menu',
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
          disableScrollLock: true,
        }}
        endAdornment={
          <InputAdornment position='end' className='custom-endAdornment'>
            {selected && (
              <IconButton
                onClick={() => handleClearSelectBox()}
                variant='onlyIcon'
                className='select-box-end-adornment-button'
              >
                <i className='bi bi-x end-adornment-close-button' />
              </IconButton>
            )}
          </InputAdornment>
        }
      >
        {isLoading || isFetching ? (
          <div className='circular-progress-box'>
            <CircularProgress size={25} />
          </div>
        ) : data && data.length > 0 ? (
          data.map((item, index) => (
            <MenuItem value={item.id} key={`role-${index + 1}`}>
              {item.name}
            </MenuItem>
          ))
        ) : (
          <div>
            <span className='no-data-found-wrapper select-box'>
              <i className='bi bi-exclamation-octagon text-lg mr-1' />{' '}
              {t('common.global.noDataFound')}
            </span>
          </div>
        )}
      </Select>
    </FormControl>
  );
};

export default RoleFilter;
